import { fulfilled, failed, pending } from "lib/promiseMiddlewareTypes";
import initialState from "store/initialState";
import { GET_TEMPLATES } from "actions/templates";

const templates = (state = initialState.templates, action: any) => {
  switch (action.type) {
    case failed(GET_TEMPLATES):
    case pending(GET_TEMPLATES):
      return [];
    case fulfilled(GET_TEMPLATES):
      return action.payload.templates;
    default:
      return state;
  }
};

export default templates;
